
function Services(element, options = {}) {
    if (!element) {
        return;
    }

    const triggers = [...element.querySelectorAll('[data-service-trigger]')];
    const panels = [...element.querySelectorAll('[data-service-panel]')];

    if (triggers?.length) {
        triggers.forEach(trigger => {

            const panel = panels.find(panel => panel.getAttribute("aria-labelledby") === trigger.id);
            if (!panel) {
                return;
            }

            const levelTriggers = [...panel.querySelectorAll('[data-lvl-trigger]')];

            const rawslug = trigger.getAttribute('data-slug');
            const slug = rawslug?.trim() ? `${rawslug.trim().toLowerCase()}` : '';

            trigger.addEventListener('click', () => {
                let currentState = history.state;
                let expanded = trigger.getAttribute('aria-expanded') === 'true' || false;

                if (!expanded) {
                    triggers.forEach((but) => but.setAttribute('aria-expanded', expanded));
                    panels.forEach((panel) => panel.hidden = true);
                    history.replaceState(currentState, null, slug ? `#${slug}` : ' ');
                    if (levelTriggers?.length) {
                        levelTriggers.forEach((but) => {
                            but.setAttribute('aria-expanded', expanded);
                            if (but.nextElementSibling) {
                                but.nextElementSibling.hidden = true;
                            }
                        });
                    }
                } else {
                    history.replaceState(currentState, null, ' ');
                }

                trigger.setAttribute('aria-expanded', !expanded);
                trigger.panel = panel;
                panel.hidden = expanded;
            });
        
            if (levelTriggers?.length) {
                levelTriggers.forEach(levelTrigger => {
                    const rawdeepSlug = levelTrigger.getAttribute('data-slug');
                    const deepSlug = rawdeepSlug?.trim() ? `/${rawdeepSlug.trim().toLowerCase()}` : '';

                    levelTrigger.addEventListener('click', () => {
                        let currentState = history.state;
                        let expanded = levelTrigger.getAttribute('aria-expanded') === 'true' || false;
        
                        if (!expanded) {
                            levelTriggers.forEach((but) => {
                                but.setAttribute('aria-expanded', expanded);
                                if (but.nextElementSibling) {
                                    but.nextElementSibling.hidden = true;
                                }
                            });

                            history.replaceState(currentState, null, slug ? `#${slug}${deepSlug}` : ' ');
                        } else {
                            history.replaceState(currentState, null, ' ');
                        }
        
                        levelTrigger.setAttribute('aria-expanded', !expanded);
                        if (levelTrigger.nextElementSibling) {
                            levelTrigger.nextElementSibling.hidden = expanded;
                        }
                    });
                });
                panel.levelTriggers = levelTriggers;
            }
        });
    }

    function getHashFromString(str) {
        if (!str || typeof str !== 'string') {
            return '';
        }
        return str.substring(str.indexOf('#') + 1);
    }

    const hashOnLoad = getHashFromString(decodeURI(location.hash)).toLowerCase();
    if (hashOnLoad) {
        const slugs = hashOnLoad.split('/');

        if (slugs?.length) {
            const startTrigger = triggers.find(t => t?.dataset?.slug?.toLowerCase() === slugs[0]);
            if (startTrigger) {
                startTrigger.dispatchEvent(new Event('click'));
                
                if (slugs?.[1] && startTrigger.panel.levelTriggers?.length) {
                    const levelTrigger = startTrigger.panel.levelTriggers.find(t => t?.dataset?.slug?.toLowerCase() === slugs[1]);
                    if (levelTrigger) {
                        levelTrigger.dispatchEvent(new Event('click'));
                    }
                }
            }
        }
    }
}
export default Services;